import axios from 'axios'

// 动态获取当前环境的基础地址
const getBaseUrl = () => {
    // 开发环境：使用代理地址（与 vue.config.js 中的 proxy 对应）
    console.log("env", process.env.NODE_ENV)
    if (process.env.NODE_ENV === 'development') {
        console.log("url", "/api")
        return '/api'
    }
    console.log("url", "localhost")
    // 生产环境：自动获取当前页面的协议、域名、端口
    const protocol = window.location.protocol // http: 或 https:
    const host = window.location.host // 域名 + 端口（如 example.com:8080）
    return `${protocol}//${host}/api`
}

const request = axios.create({
    baseURL: getBaseUrl(),
    // baseURL: `http://www.szce.com/api`,
    // baseURL: `http://119.23.229.41:11000`,
    // baseURL:`localhost:8081`,
    timeout: 30000
})


// request.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
  // config.headers['Content-Type'] = 'application/json;charset=utf-8';
  // config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  config.headers['Content-Type'] = 'application/json;charset=UTF-8';
  let user = localStorage.getItem("token") ? localStorage.getItem("token") : null
  if (user) {

    config.headers['Authorization'] = user; // 设置请求头
  }

  return config
}, error => {
  return Promise.reject(error)
});

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
  response => {
    let res = response.data;
    // 如果是返回的文件
    if (response.config.responseType === 'blob') {
      return res
    }
    // 兼容服务端返回的字符串数据
    if (typeof res === 'string') {
      res = res ? JSON.parse(res) : res
    }
    // 当权限验证不通过的时候给出提示
    if (res.code === '401') {
      // ElementUI.Message({
      //     message: res.msg,
      //     type: 'error'
      // });
      // router.push("/login")
    }
    return res;
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)


export default request



// WEBPACK FOOTER //
// ./src/utils/request.js